import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Support react-snap prerendering
if (rootElement.hasChildNodes()) {
  // Page was prerendered - hydrate
  hydrateRoot(rootElement, app);
} else {
  // Normal client-side render
  const root = createRoot(rootElement);
  root.render(app);
}
